// src/components/Header.jsx
import React, { useState } from 'react';
import '../styles/styles.css';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="header">
      <div className="logo"><a href='saadali.online'>Saad's Portfolio</a></div>
      <nav className={`nav ${isOpen ? 'open' : ''}`}>
        <a href="#about">About</a>
        <a href="#projects">Projects</a>
        <a href="#skills">Skills</a>
        <a href="#contact">Contact</a>
      </nav>
      <div className="hamburger" onClick={toggleMenu}>
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
      </div>
    </header>
  );
};

export default Header;
